module.exports = __webpack_public_path__ + "img/Marijuana (THC).1b73a79e.png";